// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2hSTc","label":"Labeled_label__H1NC7","divider":"Labeled_divider__DqzTw"};